import { useState } from 'react'
import { isValidEmail } from '../../../utility/validator'
import { toast } from 'react-toastify'
import publicService from '../../../services/publicService'
import { Typography } from '@mui/material'

const ContactUs = () => {
  const [details, setDetails] = useState({})
  const [isFormDisabled, setFormDisabled] = useState(false)

  const handleSubmitContactUs = async (e) => {
    e.preventDefault()
    if (
      isValidEmail(details.email) &&
      details.name.trim().length >= 3 &&
      details.message.trim().length >= 10
    ) {
      await publicService.contactUs(details)
      setFormDisabled(true)
    } else {
      toast.error('Put valid name, email and proper message to submit.')
    }
  }

  return (
    <section className="contact-us ">
      <Typography variant="h3" className="mb-4">
        Get in Touch with Us
      </Typography>

      <form className="contact-form" onSubmit={handleSubmitContactUs}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            disabled={isFormDisabled}
            type="text"
            id="name"
            className="form-control"
            placeholder="Enter your name"
            required
            onChange={(e) => {
              setDetails({ ...details, name: e.target.value })
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            disabled={isFormDisabled}
            type="email"
            id="email"
            className="form-control"
            placeholder="Enter your email"
            required
            onChange={(e) => {
              setDetails({ ...details, email: e.target.value })
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            disabled={isFormDisabled}
            id="message"
            className="form-control"
            rows="4"
            placeholder="Enter your message"
            required
            onChange={(e) => {
              setDetails({ ...details, message: e.target.value })
            }}
          ></textarea>
        </div>
        <button disabled={isFormDisabled} className="btn primary-btn w-100" type="submit">
          Submit
        </button>
      </form>
    </section>
  )
}

export default ContactUs
